import React from 'react'
import classnames from 'classnames'
import { stickyPanelHeaderClassName } from '../stickyPanel'

// Surface container for SABER panels. Uses the same slate-based light/dark
// surface conventions as the rest of the admin app.
export interface SaberCardProps {
  title?: React.ReactNode
  actions?: React.ReactNode
  /** Pin the header while scrolling; `top` is set from the measured page header height. */
  stickyOffset?: number
  /** Stacking order when multiple sticky headers overlap (later sections should be higher). */
  stickyZIndex?: number
  className?: string
  children?: React.ReactNode
}

export const SaberCard: React.FC<SaberCardProps> = ({
  title,
  actions,
  stickyOffset,
  stickyZIndex,
  className,
  children
}) => {
  const stickyHeader = stickyOffset != null && (title != null || actions != null)

  return (
    <section
      className={classnames(
        'relative rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-sm',
        className
      )}
    >
      {(title != null || actions != null) && (
        <header
          className={classnames(
            'flex items-center justify-between gap-2 px-4 py-3',
            stickyHeader
              ? classnames(stickyPanelHeaderClassName, 'overflow-hidden rounded-t-lg')
              : 'border-b border-slate-200 dark:border-slate-700'
          )}
          style={stickyHeader ? { top: stickyOffset, zIndex: stickyZIndex ?? 9 } : undefined}
        >
          {title != null && <h2 className="m-0 text-sm font-semibold text-slate-900 dark:text-slate-100">{title}</h2>}
          {actions != null && <div className="flex items-center gap-2">{actions}</div>}
        </header>
      )}
      <div className="p-4">{children}</div>
    </section>
  )
}

export default SaberCard
